export default __webpack_public_path__ + "fonts/iconfont.45244a3f1e0bbd27e1cbb04f3fc6440a.woff";